import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const StatsContainer = styled.div`
//   width: 100vw;
  margin-top: 100px;
//   height: 10vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
//   background: linear-gradient(145deg, #f8f9fa, #e9ecef);
//   box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.1);
`;

const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  
  .number {
    font-size: 2.5rem;
    font-weight: 700;
    color: #333;
    margin-bottom: 0.5rem;
    
    span {
      color: ${props => props.highlight || '#4254b5'};
      display: inline-block;
      transition: all 0.3s ease;
    }
  }
  
  .label {
    font-size: 1.1rem;
    color: #666;
    text-align: center;
    max-width: 200px;
    line-height: 1.4;
  }
`;

const CountingNumber = ({ end, duration = 2000, suffix = '' }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let startTime;
    let animationFrame;

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const percentage = Math.min(progress / duration, 1);
      
      // Use a cubic easing function for a smoother transition
      const easeOutCubic = 1 - Math.pow(1 - percentage, 3);
      
      setCount(Math.floor(easeOutCubic * end));

      if (percentage < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
    };
  }, [end, duration]);

  return (
    <div className="number">
      <span>{count}</span>{suffix}
    </div>
  );
};

const StatsBar = () => {
  return (
    <StatsContainer>
      <StatItem highlight="#4254b5">
        <CountingNumber end={8} suffix="+" />
        <div className="label">Projects Done</div>
      </StatItem>
      
      <StatItem highlight="#28a745">
        <CountingNumber end={30} suffix="%" />
        <div className="label">Cost Saved for Clients</div>
      </StatItem>
      
      <StatItem highlight="#ff4b4e">
        <CountingNumber end={35} suffix="%" />
        <div className="label">Faster Product Delivery for Clients</div>
      </StatItem>
    </StatsContainer>
  );
};

export default StatsBar; 